import { FetchData } from '../../cloneme-classes';
import { getCurrentDomainFolder } from '../../utils';

declare const USE_SIMPLE_LOGIN:string;

export class LogoutRedirect {
  public async init(): Promise<void> {
    await this.setup();
  }

  public async setup(): Promise<void> {
      localStorage.removeItem('jwt');
      localStorage.removeItem('username');
      localStorage.removeItem('auth0_jwt');

      function getCurrentDomainFolder() {
          const currentUrl = new URL(window.location.href);
          const hostname = currentUrl.hostname;
          const protocol = currentUrl.protocol;
          let pathSegments = currentUrl.pathname.split('/').filter(segment => segment.length > 0);

          const availableFolders = [
              'auth',
              'payments',
              'companions'
          ]
          const skipDev = true;
          const firstFolder =
              pathSegments.length > 0 && !availableFolders.includes(pathSegments[0]) && !skipDev ? `/${pathSegments[0]}` : '';

          // Construct the desired URL string
          let resultUrl = `${protocol}//${hostname}${firstFolder}`;
          return resultUrl;
      }

      window.location.href = getCurrentDomainFolder();
  }
}
